/* --------------------------------------------------------------------------
	Search Panel
-------------------------------------------------------------------------- */

/* globals jQuery, Page, Site */

(function ($, Site) {
	var $SearchPanel, $SearchClose, $SearchToggle, $ShiftingElements, LockClass;

	function init() {
		$SearchPanel = $('.js-search-panel');

		if (!$SearchPanel.length) {
			return;
		}

		$SearchToggle = $('.js-search-toggle');
		$SearchClose = $('.js-search-close-toggle');
		$ShiftingElements = $('.header, .page, .footer');
		LockClass = 'fs-page-lock';

		$SearchPanel.find('a, button, input').attr('tabindex', '-1');
		$SearchPanel
			.attr({
				role: 'dialog',
				'aria-modal': 'true'
			})
			.on('keydown', onMenuKeydown)
			.on('keyup', onMenuKeyup)
			.attr('aria-hidden', 'true');

		$SearchToggle.on('activate.swap', onMenuSwapActivate).on('deactivate.swap', onMenuSwapDeactivate).attr({ 'aria-expanded': 'false', role: 'button' });

		$SearchClose.on('keydown', onCloseKeydown).on('click', onMenuSwapDeactivate);

		// it makes no sense why a timeout is needed, but it is.
		$('.search_toggle').on('click', function () {
			setTimeout(function () { $('#search_string__panel').focus(); }, 500);
		});
	}

	function onDocumentClick(e) {
		if ($('body').hasClass(LockClass)) {
			if (!$(e.target).closest('.js-search-panel').length) {
				$SearchToggle.swap('deactivate');
			}
		}
	}

	function onMenuSwapActivate() {
		$('body').addClass(LockClass);

		$SearchToggle.attr('aria-expanded', 'true');

		$SearchPanel
			.attr({ 'aria-hidden': 'false', tabindex: '0' })
			.transition({ always: false, property: 'opacity' }, function () {
				$SearchPanel.focus();
			})
			.find('a, button, input')
			.removeAttr('tabindex');

		$ShiftingElements.css('padding-right', Page.getScrollbarWidth());

		$SearchPanel.css({
			'margin-right': '',
			width: ''
		});
	}

	function onMenuSwapDeactivate() {
		$('body').removeClass(LockClass);

		$SearchPanel.attr('aria-hidden', 'true').removeAttr('tabindex').find('a, button, input').attr('tabindex', '-1');

		$SearchToggle.attr('aria-expanded', 'false').focus();

		$ShiftingElements.css('padding-right', '');

		$SearchPanel.css({
			'margin-right': Page.getScrollbarWidth() * -1,
			width: 'calc(100% + ' + Page.getScrollbarWidth() + 'px)'
		});
	}

	function onCloseKeydown(e) {
		// tab
		if (e.keyCode === 9) {
			if (!e.shiftKey) {
				$SearchPanel.focus();
			}
		}
	}

	function onMenuKeydown(e) {
		if ($SearchPanel.is(':focus')) {
			// tab
			if (e.keyCode === 9) {
				if (e.shiftKey) {
					e.preventDefault();

					$SearchClose.focus();
				}
			}
		}
	}

	function onMenuKeyup(e) {
		// escape
		if (e.keyCode === 27) {
			$SearchToggle.swap('deactivate');
		}
	}

	Site.OnInit.push(init);
})(jQuery, Site);
